import { defineModule, } from 'direct-vuex';
import { AddressData, } from '~/utils/models';
import { isObject, } from '~/utils/models/isObject';
import { initialiseStoreValue, } from '~/utils/store';

const CustomerDetailsStorageKey = 'register.customerDetails';
const RegistrationDetailsStorageKey = 'register.registrationDetails';

export interface PhoneNumberOptions {
	countryCode: string;
	phoneNumber: string;
	phoneCode: string;
}

export interface CustomerDetails {
	customerLastName: string;
	customerNumber: string;
	numberOfOccupants: string;
	phoneNumberOption1 : PhoneNumberOptions;
	phoneNumberOption2 : PhoneNumberOptions;
}

export interface RegistrationDetails {
	customerBasicInfo: {
		firstName: string,
	};
	// securityQuestionList: {
	// 	masterId: number,
	// 	text?: string | null,
	// 	value?: string | null,
	// }[];
	address: AddressData;
}

export interface RegisterState {
	currentStep: number | null;
	customerDetails: CustomerDetails | null;
	registrationDetails: RegistrationDetails | null;
	registrationSuccessShowHeader: boolean;
	customerEmail: string;
}

function phoneNumberOptions(options: unknown): options is PhoneNumberOptions {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
	const phoneFields = options as any;

	return typeof phoneFields.countryCode === 'string' && typeof phoneFields.phoneNumber === 'string';
}

function isCustomerDetails(input: unknown): input is CustomerDetails {
	return (
		true &&
		isObject(input) &&
		typeof input.customerLastName === 'string' &&
		// typeof input.customerEmail === 'string' &&
		typeof input.customerNumber === 'number' &&
		typeof input.numberOfOccupants === 'string' &&
		typeof phoneNumberOptions(input.phoneNumberOption1) &&
		typeof phoneNumberOptions(input.phoneNumberOption2) &&
		true
	);
}

function isRegistrationDetails(input: unknown): input is RegistrationDetails {
	return (
		true &&
		isObject(input) &&
		true
	);
}

function initialiseCustomerDetails() {
	return initialiseStoreValue(
		CustomerDetailsStorageKey,
		isCustomerDetails,
		() => null,
	);
}

function initialiseRegistrationDetails() {
	return initialiseStoreValue(
		RegistrationDetailsStorageKey,
		isRegistrationDetails,
		() => null,
	);
}

export default defineModule({
	namespaced: true as const,
	state: {
		currentStep: null as (number | null),
		customerDetails: initialiseCustomerDetails(),
		registrationDetails: initialiseRegistrationDetails(),
		registrationSuccessShowHeader: true,
		customerEmail: '',
	} as RegisterState,
	getters: {
		hasExistingCustomerDetails(state) {
			return (state.customerDetails != null);
		},
		hasExistingRegistrationDetails(state) {
			return state.registrationDetails !== null;
		},
	},
	mutations: {
		setStep(state, step: RegisterState['currentStep']) {
			state.currentStep = step;
		},
		updateCustomerDetails(state, customerDetails: CustomerDetails) {
			sessionStorage.setItem(CustomerDetailsStorageKey, JSON.stringify(customerDetails));
			state.customerDetails = customerDetails;
		},
		updateRegistrationDetails(state, registrationDetails: RegistrationDetails) {
			sessionStorage.setItem(RegistrationDetailsStorageKey, JSON.stringify(registrationDetails));
			state.registrationDetails = registrationDetails;
		},
		registrationSuccessShowHeader(state, boolVal) {
			state.registrationSuccessShowHeader = boolVal;
		},
		setCustomerEmail(state, customerEmail) {
			state.customerEmail = customerEmail;
		},
		reset(state) {
			sessionStorage.removeItem(CustomerDetailsStorageKey);
			sessionStorage.removeItem(RegistrationDetailsStorageKey);
			state.customerDetails = initialiseCustomerDetails();
			state.registrationDetails = initialiseRegistrationDetails();
			state.customerEmail = '';
		},
	},
});
